import { Alert } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";

const AlertCustom = ({text, variant, showAlert, setShowAlert}) => {

  return (
    <div>
      <AnimatePresence>
        {showAlert && (
          <motion.div
            initial={{ opacity: 0, x: 50, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 50, scale: 0.9, rotate: 0 }}
            transition={{
              duration: 0.6,
              ease: "easeOut",
              type: "spring",
              stiffness: 120,
            }}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 1000,
              minWidth: "250px",
            }}
          >
            <Alert variant={variant} dismissible onClose={() => setShowAlert(false)}>
              {text}
            </Alert>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default AlertCustom;